import { IxLookupFilterDTO } from 'ix-ng-components';
import { Maybe } from 'ix-ng-static-utils';

export class ObcinaLookupDTO {
  siObcinaId: Maybe<number> = null;
  naziv: Maybe<string> = null;
  aktiven: Maybe<boolean> = null;
}

export class ObcinaLookupFilterDTO extends IxLookupFilterDTO<number> {
  prikaziAktivne: Maybe<boolean> = null;
}
